import type { DivisionJob } from '../hooks/useSchedulerGeneration'

/**
 * "All rules satisfied" is a FLIGHT-WIDE claim, so it is only true when the whole
 * generation has conclusively finished AND every division was strictly satisfied
 * (solved with every enabled constraint as hard — `constraints_relaxed === false`).
 *
 * It returns false when any division is still `pending`/`processing` (transient —
 * don't flash the chip mid-stream), `failed` (a division that couldn't be
 * scheduled at all must not read as "all rules satisfied"), relaxed
 * (`constraints_relaxed === true`), or pre-feature (`null`). An empty job list is
 * false — there is nothing to make the claim about.
 *
 * This deliberately does NOT consider only the completed subset: claiming universal
 * satisfaction while some divisions are unfinished or failed would overclaim.
 */
export const allConstraintsStrictlySatisfied = (
  jobs: DivisionJob[] | null | undefined
): boolean => {
  if (!jobs || jobs.length === 0) {
    return false
  }
  return jobs.every(
    (job) => job.status === 'completed' && job.constraints_relaxed === false
  )
}
